import SingleDropdown, {
  SingleDropdownItem,
} from "@/components/common/single-dropdown/single-dropdown";
import { selectCategory } from "@/store/slices/category";
import { useRouter } from "next/router";
import React from "react";
import { useSelector } from "react-redux";

const CollectionFilter = () => {
  const router = useRouter();
  const categoryState = useSelector(selectCategory);
  const [filterCategories, setFilterCategories] = React.useState<
    SingleDropdownItem[]
  >([]);

  React.useEffect(() => {
    const values =
      categoryState?.facets?.find((x: any) => x.key == "categories")?.data ||
      [];

    if (router.route == "/jewellery") {
      setFilterCategories([]);
    } else {
      setFilterCategories(
        values
          .filter((v: any) => v.data.parentId == categoryState.data?.id)
          .map((v: any) => ({
            label: `${v.label} (${v.count})`,
            value: v.data?.url,
          }))
      );
    }
  }, [categoryState, router.route]);

  if (filterCategories.length == 0) {
    return <></>;
  }

  return (
    <SingleDropdown
      label="CATEGORIES"
      items={filterCategories}
      onChange={(value: any) =>
        router.push({
          pathname: `/jewellery/category/${
            value.split("/jewellery/category/")[1]
          }`,
        })
      }
    />
  );
};

export default CollectionFilter;
